import * as actionTypes from './actionTypes';

export const saveConfig = (config) => {
    return {
        type: actionTypes.SAVE_CONFIG,
        config
    }
}

export const setIsMobile = (isMobile) => {
    return {
        type: actionTypes.SET_IS_MOBILE,
        isMobile
    }
}

export const setIsMenuMobileSelected = (isMenuMobileSelected) => {
    return {
        type: actionTypes.SET_IS_MENU_MOBILE_SELECTED,
        isMenuMobileSelected
    }
}